var React = require('react');

function LeftArrowThin (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},[React.createElement("style",{"key":0},".a{fill:#f5f7fb;}.b{clip-path:url(#a);}"),React.createElement("clipPath",{"id":"a","key":1},React.createElement("rect",{"className":"a","width":"24","height":"23.988"}))]),React.createElement("g",{"transform":"translate(165 23.482) rotate(180)","key":1},React.createElement("g",{"transform":"translate(141 -0.506)"},React.createElement("g",{"className":"b"},React.createElement("path",{"className":"a","d":"M11,6l3-3L11,0l-.707.707L12.086,2.5H0v1H12.086L10.293,5.29Z","transform":"translate(5 9)"}))))]);
}

LeftArrowThin.defaultProps = {"width":"24","height":"23.988","viewBox":"0 0 24 23.988"};

module.exports = LeftArrowThin;

LeftArrowThin.default = LeftArrowThin;
